<script setup lang="ts">
const { allDepositMethods } = usePayments();

type Props = {
  selectedDepositMethod?: PaymentsMethodsType;
  isResultScreen?: boolean;
};

const { selectedDepositMethod, isResultScreen = false } = defineProps<Props>();

type Emits = {
  'select-deposit-method': [PaymentsMethodsType];
};

const emit = defineEmits<Emits>();

const { isMobile } = useLayout();
</script>

<template>
  <div
    v-if="!isResultScreen"
    :class="$style.methodSelector"
  >
    <LazyWidgetsCarousel
      :display="{ spaceBetweenItems: [12, 10] }"
      :enable-navigation-buttons="!isMobile"
      item-class="w-auto select-none"
      :items="allDepositMethods"
      :navigation-always-visible="!isMobile"
      slider-fade="both"
    >
      <template #item="{ item }">
        <div
          :class="[
            $style.methodItem,
            { [$style.isActive]: selectedDepositMethod === item.slug },
            { [$style.isCrypto]: item.slug === 'crypto' },
          ]"
          :title="item.title"
          @click="emit('select-deposit-method', item.slug)"
        >
          <template v-if="item.slug === 'crypto'">
            <DepositCryptoIcons :icons-quantity="3" />
          </template>
          <template v-else>
            <NuxtIcon
              :class="$style.paymentLogo"
              :filled="true"
              :name="item.icon"
            />
          </template>
        </div>
      </template>
    </LazyWidgetsCarousel>
  </div>
</template>

<style module lang="postcss">
.methodSelector {
  @apply w-full;

  .methodItem {
    @apply text-texts text-sm font-semibold flex items-center justify-center rounded-lg border-primary/30 border border-solid bg-auth-bg-inputs/30 w-28 h-12 p-3 cursor-pointer;

    @media (hover: hover) {
      @apply transition-all duration-200;
      &:hover {
        @apply bg-auth-bg-inputs/40 border-primary/40;
      }
    }

    &.isActive {
      @apply border-primary;
    }

    &.isCrypto {
      @apply w-36 md:w-36;
    }

    .paymentLogo {
      @apply h-full w-full;
      svg {
        @apply h-full w-full;
      }
    }
  }
}
</style>
